/* eslint-disable custom/no-hardcoded-colors */
import { styled } from 'design-system';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import React from 'react';

const Banner = styled('div', {
  height: '150px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 10px',
  position: 'relative',
  zIndex: 1,
});

const Column = styled('div', {
  textAlign: 'left',
  borderLeft: '1px solid white',
  paddingLeft: '85px',

  '&:first-child': {
    borderLeft: 'none',
  },
  height: '100px',
});

const Header = styled('h1', {
  fontWeight: '700',
  fontSize: '28px',
  lineHeight: '36px',
  color: 'white',
  marginBottom: '6px',
});

const Content = styled('p', {
  fontWeight: '400',
  fontSize: '18px',
  lineHeight: '24px',
  color: 'white',
});

export const BlueBanner = () => {
  const t = useTranslation('homepage').t;

  return (
    <Banner>
      <Column
        data-test-id="column-2"
        role="region"
        aria-labelledby="header-2"
        style={{ paddingLeft: '0px', paddingRight: '70px' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <Image src="/journal-rec.svg" width={36} height={36} alt={''} />
          <Header id="header-2" style={{ marginBottom: '0' }}>
            1500+
          </Header>
        </div>
        <Content style={{ width: '100%' }}>
          {t(
            'section2_v2.journal_recommend',
            'journals recommend Preflight before submission',
          )}
        </Content>
      </Column>
      <Column data-test-id="column-3" role="region" aria-labelledby="header-3">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <Image src="/author-rec.svg" width={36} height={36} alt={''} />
          <Header id="header-3" style={{ marginBottom: '0' }}>
            400k+
          </Header>
        </div>
        <Content style={{ width: '90%' }}>
          {t(
            'section2_v2.pre_submission_checks',
            'authors opted for the pre-submission checks to ensure quality and accuracy',
          )}
        </Content>
      </Column>
      <Column data-test-id="column-1" role="region" aria-labelledby="header-1">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          <Image src="/manuscript-rec.svg" width={36} height={36} alt={''} />
          <Header id="header-1" style={{ marginBottom: '0' }}>
            700k+
          </Header>
        </div>
        <Content style={{ width: '98%' }}>
          {t(
            'section2_v2.submission_readiness',
            'manuscripts processed to check their submission readiness',
          )}
        </Content>
      </Column>
    </Banner>
  );
};
